import { render, staticRenderFns } from "./getTypes.vue?vue&type=template&id=43d313ea&scoped=true"
import script from "./getTypes.vue?vue&type=script&lang=js"
export * from "./getTypes.vue?vue&type=script&lang=js"
import style0 from "./getTypes.vue?vue&type=style&index=0&id=43d313ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d313ea",
  null
  
)

export default component.exports